import React, { useEffect, useState } from "react";

const AppWrapper = ({ children }) => {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
  }, []);

  const simulatedStyle = {
    maxWidth: "430px",         // iPhone X width
    border: "1px solid #ccc",
    margin: "0 auto",
	paddingBottom: "15px",
	width:"100%",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    overflow: "none"
  };

  return (
    <div style={!isMobile ? simulatedStyle : {}}>
      {children}
    </div>
  );
};

export default AppWrapper;
